import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";

import { fetchDipStocks, selectDipStocks } from "../../dip/DipSlice";
import { selectUserWatchlist, selectIndices } from "../../watchlist/WatchlistSlice";
import styles from "./MobileDip.module.css";
import "rsuite/dist/rsuite.min.css";
import "../../../util/css/Table.css";
import DipGallery from "../../../components/gallery/DipGallery";
import ScrollToTop from "../../../components/ScrollToTop/ScrollToTop";

const MobileDip = () => {

    const [dipThreshold, setDipThreshold] = useState(1);
    const [dipDuration, setDipDuration] = useState(3);
    const [isGalleryMode, setIsGalleryMode] = useState(false);
    const dispatch = useDispatch();
    const dip_stocks = useSelector(selectDipStocks);
    const watchlists = useSelector(selectUserWatchlist) || [];
    const indices = useSelector(selectIndices) || [];
    const months_array = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
    const [watchlistSelected, setWatchlistSelected] = useState('');
    const [indexSelected, setIndexSelected] = useState('');

    const handleGalleryModeChange = (galleryMode) => {
        setIsGalleryMode(galleryMode);
    };

    useEffect(() => {
        //TO DO - Validate selection. Handle edge cases/ watchlist/index
        //Set a default watchlist selected
        setIndexSelected(indices[0].indexUId);
        console.log(indices[0].indexUId);
        const req = {
            months: dipDuration,
            threshold: dipThreshold,
            indexUId: indices[0].indexUId
        };
        dispatch(fetchDipStocks(req));
    }, [dispatch]);


    // const fetchCustomDipList = () => {
    //     const req = {
    //         months: parseInt(dipDuration, 10),
    //         threshold: parseInt(dipThreshold, 10),
    //     };
    //     if (watchlistSelected) req.watchlistUId = watchlistSelected;
    //     if (indexSelected) req.indexUId = indexSelected;

    //     console.log(req)
    //     dispatch(fetchDipStocks(req));
    // }

    const handleGroupSelection = (value, flag) => {
        if (flag === "W") {
            setWatchlistSelected(value);
            setIndexSelected("");
        } else {
            setWatchlistSelected("");
            setIndexSelected(value);
        }
    }

    useEffect(() => {
        const hasGroup = !!watchlistSelected || !!indexSelected;
        const hasAllFields = hasGroup && dipThreshold && dipDuration;

        if (hasAllFields) {
            const req = {
                months: parseInt(dipDuration, 10),
                threshold: parseInt(dipThreshold, 10),
            };
            if (watchlistSelected) req.watchlistUId = watchlistSelected;
            if (indexSelected) req.indexUId = indexSelected;

            dispatch(fetchDipStocks(req));
        }
    }, [watchlistSelected, indexSelected, dipThreshold, dipDuration, dispatch]);


    return (
        <div className="">
            <div className={`${styles.wrapper}`}>
                {!isGalleryMode && (
                    <div className={`${styles.filter_section}`}>
                        <div className={`form-row ${styles.inp_btn_wrapper}`}>
                            <div className={styles.filter_inputs_wrapper}>
                                <div className={`${styles.watchlist_dropdown_wrapper}`}>
                                    <div className={styles.floating_select_wrapper}>
                                        <select 
                                            className={`${watchlistSelected === '' ? styles.grey_text : styles.black_text}`} 
                                            value={watchlistSelected} 
                                            onChange={(event) => handleGroupSelection(event.target.value, 'W')}
                                            aria-label="Select watchlist"
                                            tabIndex={0}
                                        >
                                            <option disabled value=''> Watchlist</option>
                                            {watchlists.map((item, index) => (
                                                <option key={index} value={item.watchlistUId}>{item.watchlistName}</option>
                                            ))}
                                        </select>
                                        <label className={styles.floating_label}>Watchlist</label>
                                    </div>
                                </div>

                                <div className={styles.watchlist_dropdown_wrapper}>
                                    <div className={styles.floating_select_wrapper}>
                                        <select 
                                            className={`${indexSelected === '' ? styles.grey_text : styles.black_text}`} 
                                            value={indexSelected} 
                                            onChange={(event) => handleGroupSelection(event.target.value, "I")}
                                            aria-label="Select index"
                                            tabIndex={0}
                                        >
                                            <option disabled value=''>Index</option>
                                            {indices.map((item, index) => (
                                                <option key={index} value={item.indexUId}>{item.indexName}</option>
                                            ))}
                                        </select>
                                        <label className={styles.floating_label}>Index</label>
                                    </div>
                                </div>

                                <div className={`${styles.search_input_wrapper}`}>
                                    <div className={styles.floating_label_1}>
                                        <input
                                            type="number"
                                            placeholder=" "
                                            min={1}
                                            name="dippercent"
                                            value={dipThreshold}
                                            onChange={(event) => setDipThreshold(event.target.value)}
                                            aria-label="Dip percentage"
                                            tabIndex={0}
                                        />
                                        <label htmlFor="dippercent">Dip %</label>
                                    </div>
                                </div>

                                <div className={`${styles.search_input_wrapper}`}>
                                    <div className={styles.floating_select_wrapper}>
                                        <select 
                                            className={`${dipDuration === '' ? styles.grey_text : styles.black_text}`} 
                                            value={dipDuration} 
                                            onChange={(event) => setDipDuration(event.target.value)}
                                            aria-label="Select months"
                                            tabIndex={0}
                                        >
                                            {months_array.map((month) => (
                                                <option key={month} value={month}>{month}</option>
                                            ))}
                                        </select>
                                        <label className={styles.floating_label}>Months</label>
                                    </div>
                                </div>
                            </div>
                            <div className={`${styles.centered_button}`}></div>
                        </div>
                    </div>
                )}

                <div>
                    {dip_stocks && (
                        <DipGallery 
                            stocks={dip_stocks} 
                            onGalleryModeChange={handleGalleryModeChange} 
                        />
                    )}
                </div>
                {!isGalleryMode && <ScrollToTop />}
            </div>
        </div>
    )
}

export default MobileDip